export const constructionEndDateOptions = [
    {label: "Gotowe do odbioru", value: 0},
    {label: "Do 3 miesięcy", value: 3},
    {label: "Do 6 miesięcy", value: 6},
    {label: "Do roku", value: 12},
    {label: "Do 3 lat", value: 36}
];
export const constructionEndDateOptions = [
    {label: "Gotowe do odbioru", value: 0},
    {label: "Do 3 miesięcy", value: 3},
    {label: "Do 6 miesięcy", value: 6},
    {label: "Do roku", value: 12},
    {label: "Do 3 lat", value: 36}
];
